/* Spanish translations for portfolio */

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

// Splash Screen (same for both languages)
const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

// Summary And Greeting Section
const illustration = {
  animated: true
};

const greeting = {
  username: "danielduran.dev",
  title: "Hola, soy Daniel",
  subTitle: emoji(
    "Desarrollador web con 2 años de experiencia en tecnologías frontend (Angular y React) y backend (Node.js, Java, Spring). Busco seguir creciendo profesionalmente en empresas innovadoras. Me apasionan la inteligencia artificial y la gestión de producto. Aprendo rápido y destaco por mis habilidades para comunicar y resolver problemas, desarrolladas a través de una formación sólida y experiencias internacionales.\n"
  ),
  resumeLink:
    "https://danieldurandev-assets.s3.eu-south-2.amazonaws.com/Daniel_Duran_Resume_EN_Public.pdf", // Déjalo vacío para ocultar el botón
  displayGreeting: true, // Ponlo en false para ocultar esta sección, por defecto es true
  contactMe: "Contacta conmigo",
  downloadMyResume: "Descarga mi currículum"
};

// Social Media Links (same for both languages)
const socialMediaLinks = {
  github: "https://github.com/danielduri",
  linkedin: "https://www.linkedin.com/in/danielduranr/",
  gmail: "hello@danielduran.dev",
  display: true
};

// Skills Section
const skillsSection = {
  linkName: "Habilidades",
  title: "Lo que hago",
  subTitle: "DOMINO ESTAS TECNOLOGÍAS, PERO SIEMPRE BUSCO APRENDER MÁS",
  subTitle2: "QUIERO SEGUIR APRENDIENDO SOBRE",
  skills: [
    emoji(
      "⚡ Desarrollo tanto en frontend como en backend, creando interfaces intuitivas y sistemas robustos que escalan con el producto"
    ),
    emoji(
      "⚡ Entiendo los objetivos de negocio y los transformo en soluciones útiles y atractivas."
    ),
    emoji(
      "⚡ Trabajo en equipo con perfiles multidisciplinares para entregar software de calidad que responda a las necesidades del negocio y de los usuarios."
    ),
  ],  
  softwareSkills: [
    {
      skillName: "HTML",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Spring",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "GCP",
      fontAwesomeClassname: "fab fa-google"
    }
  ],
  otherSkills: [
    {
      skillName: "Gestión de Productos",
      fontAwesomeClassname: "fas fa-flag-checkered"
    },
    {
      skillName: "Inteligencia Artificial",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "Desarrollo Móvil",
      fontAwesomeClassname: "fas fa-mobile-alt"
    },
    {
      skillName: "Charlas y Eventos",
      fontAwesomeClassname: "fas fa-comments"
    }
  ],
  display: true
};

// Education Section
const educationInfo = {
  linkName: "Educación",
  display: true,
  sectionTitle: "Educación",
  schools: [
    {
      schoolName: "Universidad Complutense de Madrid",
      logo: require("./assets/images/ucmLogo.png"),
      subHeader: "Doble Grado en Ingeniería Informática y Administración de Empresas",
      duration: "Septiembre 2017 - Mayo 2023",
      desc: "Proyecto final: desarrollo de una aplicación para la gestión de guías docentes utilizando Microsoft Azure AI y OpenAI GPT. Calificación: 9,5/10.",
      descBullets: [
        "Otros proyectos: simulador de física [Java], clon de Plants vs. Zombies [Java], tienda online en WordPress, aplicación de gestión de eventos [Java], plataforma de cursos de videojuegos [HTML+CSS+PHP]",
        "Áreas técnicas: estructuras de datos y algoritmos, sistemas operativos, arquitectura de computadores, ingeniería del software, redes de computadoras, seguridad de redes, interacción persona-ordenador",
        "Áreas empresariales: finanzas y economía, contabilidad, operaciones, marketing, producto, estrategia, innovación, legislación, recursos humanos"
      ]
    },
    {
      schoolName: "Fundación Amancio Ortega",
      logo: require("./assets/images/fundacin_amancio_ortega_logo.jpeg"),
      subHeader: "Programa de Año Escolar en el Extranjero - Hutchinson, KS, EE.UU.",
      duration: "Agosto 2015 - Mayo 2016",
      desc: "Seleccionado entre miles de estudiantes para una prestigiosa beca que reconoce la excelencia académica y el potencial de liderazgo, cursando un año escolar en EE.UU.",
      descBullets: [
        "Convivencia e intercambio con estudiantes de distintos países y culturas.",
        "Seleccionado posteriormente por el equipo del programa entre antiguos becados para ser Embajador del Programa.",
        "Apoyé a más de 500 nuevos becarios al impartir talleres de orientación, organizando actividades culturales y ejerciendo mentoría para facilitar su adaptación, aumentando la participación y el sentimiento de comunidad."
      ]
    }
  ]  
};

// Tech Stack
const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: "Frontend/Diseño",
      progressPercentage: "90%"
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programación",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false
};

// Work experience section
const workExperiences = {
  linkName: "Experiencia",
  display: true, // Ponlo en true para mostrar la sección de experiencia
  sectionTitle: "Experiencia",
  experience: [
    {
      role: "Ingeniero de Software de Producto",
      company: "Swiss Re",
      companylogo: require("./assets/images/swissRelogo.jpg"),
      date: "Mayo 2025 – Presente",
      desc: "Construir y mantener el servicio de Pólizas, un componente clave en una plataforma de seguros basada en microservicios con más de 30,000 pólizas activas, desarrollado con Java Spring y Docker.",
      descBullets: [
        "Lideré el desarrollo de un nuevo sistema para la gestión de facturas médicas y un registro de auditoría de acciones de usuarios, impulsando el diseño e implementación para mejorar la eficiencia operativa y el cumplimiento.",
        "Colaboro con product managers e ingenieros para alinear las funcionalidades técnicas con los objetivos del negocio.",
        "Utilizo testing automatizado, feature flags y CI/CD para asegurar lanzamientos de alta calidad."
      ]
    },
    {
      role: "Ingeniero de Software",
      company: "Indra Deimos",
      companylogo: require("./assets/images/deimosLogo.png"),
      date: "Marzo 2023 – Mayo 2025",
      desc: "Desarrollé y desplegué soluciones frontend y backend para varios clientes. Redacté documentación técnica.",
      descBullets: [
        "Diseñé e implementé el frontend de un proyecto eHealth para un hospital público destacado.",
        "Integré pulseras inteligentes Fitbit mediante su API.",
        "Contribuí a la evolución de una aplicación de gestión de procesos para una gran empresa de infraestructuras, mejorando la satisfacción del usuario.",
        "Impulsé la adopción de GitHub Copilot en los equipos de desarrollo liderando talleres para más de 20 ingenieros, aumentando la satisfacción y productividad."
      ]
    },
    {
      role: "Beca en Gestión de Producto",
      company: "Dost",
      companylogo: require("./assets/images/dostLogo.png"),
      date: "Diciembre 2022 – Marzo 2023",
      desc: "Fui el punto de contacto entre clientes y un equipo de producto multicultural, asegurando la resolución de bugs y atencion a las solicitudes.",
      descBullets: [
        "Realicé entrevistas y encuestas a usuarios para identificar sus necesidades y preferencias.",
        "Ayudé a los usuarios a navegar por la plataforma y les proporcioné soporte técnico.",
        "Incrementé la satisfacción del cliente resolviendo sus inquietudes con profesionalidad."
      ]
    },
    {
      role: "Beca en Gestión de Identidad y Accesos",
      company: "Bankinter",
      companylogo: require("./assets/images/bkLogo.png"),
      date: "Enero 2022 – Julio 2022",
      desc: "Gestioné las identidades de más de 6,000 empleados y 10,000 contratistas externos, otorgándoles acceso a los recursos y carpetas compartidas correspondientes.",
      descBullets: [
        "Colaboré con el equipo de ciberseguridad para asegurar el cumplimiento de las políticas de seguridad del banco.",
        "Seguí buenas prácticas del sector financiero verificando autorizaciones para cada solicitud de acceso y rcreando registros auditables, fomentando una cultura de seguridad y responsabilidad en toda la organización."
      ]
    }
  ]
};

const openSource = {
  linkName: "Código Abierto",
  showGithubProfile: false,
  display: false
};

// Projects
const bigProjects = {
  linkName: "Proyectos",
  title: "Proyectos",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/syllabusLogo.png"),
      projectName: "SyllabusCentral",
      projectDesc: "Aplicación de gestión de guías docentes impulsada por IA",
      footerLink: [
        {
          name: "Ver demo",
          url: "https://drive.google.com/file/d/1KLfY3WlP6Vz_KFfw-OtNJuZElOl3kfgu/view"
        },
        {
          name: "Leer informe",
          url: "https://danieldurandev-assets.s3.eu-south-2.amazonaws.com/Daniel_Duran_Final_Project_CS.pdf"
        }
      ]
    },
    {
      image: require("./assets/images/psLogo.jpeg"),
      projectName: "Análisis de Marca PlayStation",
      projectDesc: "Proyecto de Administración de Empresas analizando la evolución de la marca PlayStation",
      footerLink: [
        {
          name: "Leer",
          url: "https://danieldurandev-assets.s3.eu-south-2.amazonaws.com/Daniel_Duran_Final_Project_BA.pdf"
        }
      ]
    }
  ],
  display: true
};

// Achievement Section
const achievementSection = {
  linkName: "Certificaciones",
  title: emoji("Certificaciones"),
  subtitle: "",
  achievementsCards: [
    {
      title: "Google Cloud - Professional Data Engineer",
      subtitle: "Noviembre 2022",
      image: require("./assets/images/PDEbadge.png"),
      footerLink: [
        {
          name: "Certificado",
          url: "https://www.credly.com/badges/512db318-2a87-49a0-9321-125a6c721f6d/public_url"
        }
      ]
    },
    {
      title: "Google Cloud - Cloud Associate Engineer",
      subtitle: "Agosto 2022",
      image: require("./assets/images/ACEbadge.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certificado",
          url: "https://www.credly.com/badges/c2235f3f-a60b-4409-a26b-c36fd9b8fb97/public_url"
        }
      ]
    },
    {
      title: "Google Project Management Certificate",
      subtitle: "Agosto 2021",
      image: require("./assets/images/GPMbadge.png"),
      footerLink: [
        {name: "Certificado", url: "https://www.credly.com/badges/7c5025f1-c70a-41cb-a3e5-b6a2b30fa6fd/public_url"},
      ]
    }
  ],
  display: true
};

// Blogs Section
const blogSection = {
  linkName: "Blogs",
  title: "Blogs",
  subtitle:
    "Con amor por desarrollar cosas geniales, me encanta escribir y enseñar a otros lo que he aprendido.",
  displayMediumBlogs: "true",
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Gana una camiseta de Google Assistant y $200 en créditos de Google Cloud",
      description:
        "¿Quieres ganar $200 y una camiseta de Google Assistant creando una acción de Google Assistant en menos de 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "¿Por qué REACT es el mejor?",
      description:
        "React es una biblioteca de JavaScript para construir interfaces de usuario. Es mantenida por Facebook y una comunidad de desarrolladores individuales y empresas."
    }
  ],
  display: false
};

// Talks Sections
const talkSection = {
  linkName: "Charlas",
  title: "CHARLAS",
  subtitle: emoji(
    "ME ENCANTA COMPARTIR MI CONOCIMIENTO LIMITADO Y OBTENER UNA INSIGNIA DE PONENTE 😅"
  ),
  talks: [
    {
      title: "Construir Acciones Para Google Assistant",
      subtitle: "Codelab en GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false
};

// Podcast Section
const podcastSection = {
  linkName: "Podcast",
  title: emoji("Podcast 🎙️"),
  subtitle: "ME ENCANTA HABLAR SOBRE MÍ Y LA TECNOLOGÍA",
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false
};

// Resume Section
const resumeSection = {
  title: "Currículum",
  subtitle: "Siéntete libre de descargar mi currículum",
  display: true
};

const contactInfo = {
  linkName: "Hablemos",
  title: emoji("¿Hablamos? 🤙🏽"),
  subtitle:
    "Mi bandeja de entrada y DMs están siempre a tu disposición. ¡Hagámoslo!",
  email_address: "hello@danielduran.dev"
};

// Twitter Section
const twitterDetails = {
  userName: "twitter",
  display: false
};

const isHireable = true;

// Footer Section
const footerSection = {
  text: emoji("Hecho con ❤️ desde 40.416729, -3.703339"),
  themeBy: "Diseño por",
  themeLink: "https://github.com/saadpasta/developerFolio",
  themeName: "developerFolio",
  thanks: "(¡gracias! :D)"
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  footerSection
};

